import React, { useEffect, useState } from 'react'
import SubMenu from './sub-menu'
import trainingMenu from './data/training.json'
import freeResourcesMenu from './data/free-resources.json'

import logoImg from '../../images/logo@2x.png'
import './style.css'

const SiteHeader = () => {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false)
  const [isLogin, setIsLogin] = useState(false)

  useEffect(() => {
    if (document.cookie.includes('wordpress_logged_in_pocket_seises')) {
      setIsLogin(true)
    }
  }, [])

  const isShowNavbarClass = isNavbarOpen ? '_show' : ''

  return (
    <header className='site-header'>
      <h1 className='site-header-title'>Poker</h1>
      <div className='container site-header-container'>
        <button
          onClick={() => setIsNavbarOpen((state) => !state)}
          className={`site-header-toggle-navbar ${isShowNavbarClass}`}
        >
          <div
            className={`site-header-toggle-navbar-line ${isShowNavbarClass}`}
          />
        </button>

        <a href='/'>
          <img
            src={logoImg}
            width='300'
            height='21'
            alt='Logo'
            className='site-header-logo'
          />
        </a>
        <nav className='site-header-menu'>
          <ul>
            <li>
              <a href='/' className='site-header-item site-header-item-active'>
                Home
              </a>
            </li>
            <li>
              <a
                href='/peakgto'
                target='_blank'
                rel='noreferrer'
                className='site-header-item'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '60px',
                }}
              >
                <img
                  src='https://pokercoaching.com/wp-content/uploads/2024/12/peakgto_stacked.png'
                  alt='PeakGTO - Elevate Your Game'
                  height='30'
                />
                &nbsp;
              </a>
            </li>
            <li>
              <a className='site-header-item'>Training</a>
              <div className='site-header-submenu'>
                <SubMenu menu={trainingMenu} />
              </div>
            </li>
            <li>
              <a
                href='/blog/category/poker-quizzes/'
                className='site-header-item'
              >
                Quizzes
              </a>
            </li>
            <li>
              <a href='/blog/' className='site-header-item'>
                Articles
              </a>
            </li>
            <li>
              <a className='site-header-item'>Free Resources</a>
              <div className='site-header-submenu'>
                <SubMenu menu={freeResourcesMenu} />
              </div>
            </li>
            <li>
              {isLogin && (
                <a
                  href='/my-account/'
                  target='_blank'
                  rel='noreferrer'
                  className='site-header-item'
                >
                  My Account
                </a>
              )}
              {!isLogin && (
                <a href='/login' className='site-header-item site-header-item-member-login'>
                  Member Login
                </a>
              )}
            </li>
          </ul>
        </nav>
      </div>

      <div className={`mobile-navbar ${isShowNavbarClass}`}>
        <ul className='site-header-menu _mobile'>
          <li>
            <a href='/' className='site-header-item'>
              Home
            </a>
          </li>
          <li>
            <a
              href='/peakgto'
              target='_blank'
              rel='noreferrer'
              className='site-header-item'
              style={{ margin: '10px auto' }}
            >
              <img
                src='https://pokercoaching.com/wp-content/uploads/2024/12/peakgto_stacked.png'
                alt='PeakGTO - Elevate Your Game'
                width='60'
              />
            </a>
          </li>
          <li>
            <div className='site-header-submenu'>
              <SubMenu menu={trainingMenu} />
            </div>
          </li>
          <li>
            <a
              href='/blog/category/poker-quizzes/'
              className='site-header-item'
            >
              Quizzes
            </a>
          </li>
          <li>
            <a
              href='https://pokercoaching.com/blog/'
              className='site-header-item'
            >
              Articles
            </a>
          </li>
          <li>
            <div className='site-header-submenu'>
              <SubMenu menu={freeResourcesMenu} />
            </div>
          </li>
          <li>
            {isLogin && (
              <a
                href='/my-account/'
                target='_blank'
                rel='noreferrer'
                className='site-header-item'
              >
                My Account
              </a>
            )}
            {!isLogin && (
              <a href='/login' className='site-header-item'>
                Member Login
              </a>
            )}
          </li>
        </ul>
      </div>
    </header>
  )
}

export default SiteHeader
